import moment from "moment";
import React from "react";
import cslx from "clsx";
import MaskedInput from "react-text-mask";

const acceptedDateFormats = [
    'DD-MM YYYY',
    'DD-MMM YYYY',
    'DD MMM YYYY',
    'DD MM YYYY',
]

const parsingDateFormats = [...acceptedDateFormats, 'MM/DD/YYYY'];

class DateInput extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const handleInputChange = (e) => {
            if (this.props.allowNull && (!e.target.value||e.target.value.length === 0)) {
                this.props.onChange(null)
            } else {
                let inputDate = moment(e.target.value, acceptedDateFormats, true);
                
                if (!inputDate.isValid()) {
                    return;
                }

                if(this.props.hasOwnProperty('onChange')) {
                    this.props.onChange(inputDate.format("DD-MMM YYYY"));
                } 
            }
        }

        const handleInputBlur = (e) => {
            if(e) {
                const inputDate = moment(e.target.value, acceptedDateFormats, true);
                
                const inputDateStr = !inputDate.isValid()
                    ? null
                    : inputDate.format("DD-MMM YYYY");

                if(this.props.hasOwnProperty('onBlur')) {
                    this.props.onBlur(inputDateStr);
                } 
            }
        }

        const dateFormat = this.props.dateFormat
            ? this.props.dateFormat
            : "DD-MMM YYYY";
        const value = this.props.value 
            ? moment(this.props.value, parsingDateFormats).format(dateFormat) 
            : null;
        
        return (
            <MaskedInput 
                guide={false} 
                mask={[/\d/, /\d/, /[-/\\]|\s|[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z]|[-/\\]|\s|\d/, /\s|[-/\\]|\d/, /\d/, /\d/, /\d/, /\d/]}  
                placeholder="dd-mmm yyyy" 
                type="text" 
                class={cslx([this.props.class ? this.props.class : "", 'disabled:!tw-bg-cfo-grey-500'])}
                value={value} 
                onChange={handleInputChange}
                onBlur={handleInputBlur}
                onFocus={this.props.onFocus}
                disabled={this.props.disabled}
            />
        )
    }
}

export default DateInput;